// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  restaurantId: __t.u64().name("restaurant_id"),
  clientTempId: __t.string().name("client_temp_id"),
  variant: __t.string(),
  archetype: __t.string(),
  tasteDiet: __t.string().name("taste_diet"),
  tasteDecorPref: __t.f32().name("taste_decor_pref"),
  tasteWindowPref: __t.f32().name("taste_window_pref"),
  tasteCuisineBias: __t.string().name("taste_cuisine_bias"),
  tasteDrinkTolerance: __t.f32().name("taste_drink_tolerance"),
  willUseToilet: __t.bool().name("will_use_toilet"),
  state: __t.string(),
  stateClockMs: __t.i64().name("state_clock_ms"),
  patienceMs: __t.i64().name("patience_ms"),
  seatUid: __t.string().name("seat_uid"),
  seatX: __t.f32().name("seat_x"),
  seatZ: __t.f32().name("seat_z"),
  seatFacingY: __t.f32().name("seat_facing_y"),
  seatFloor: __t.u32().name("seat_floor"),
  seatAtBar: __t.bool().name("seat_at_bar"),
  plateX: __t.f32().name("plate_x"),
  plateZ: __t.f32().name("plate_z"),
  x: __t.f32(),
  z: __t.f32(),
  floor: __t.u32(),
  targetX: __t.f32().name("target_x"),
  targetZ: __t.f32().name("target_z"),
  targetFloor: __t.u32().name("target_floor"),
  orderRecipes: __t.string().name("order_recipes"),
  orderIndex: __t.u32().name("order_index"),
  ticketId: __t.option(__t.u64()).name("ticket_id"),
  reservedDishTiers: __t.string().name("reserved_dish_tiers"),
  waitingChairUid: __t.string().name("waiting_chair_uid"),
  waitingTimeoutMs: __t.i64().name("waiting_timeout_ms"),
  totalPaidCents: __t.i64().name("total_paid_cents"),
  totalSatisfactionX100: __t.i32().name("total_satisfaction_x100"),
  dishesSettled: __t.bool().name("dishes_settled"),
  spawnedAt: __t.timestamp().name("spawned_at"),
  wcTargetUid: __t.option(__t.string()).name("wc_target_uid"),
  orderAppliances: __t.option(__t.string()).name("order_appliances"),
  orderCookSecondsCsv: __t.option(__t.string()).name("order_cook_seconds_csv"),
  doorX: __t.f32().name("door_x"),
  doorZ: __t.f32().name("door_z"),
  doorFloor: __t.u32().name("door_floor"),
  orderPricesCsv: __t.option(__t.string()).name("order_prices_csv"),
  orderSatisfactionsCsv: __t.option(__t.string()).name("order_satisfactions_csv"),
  patienceMultX100: __t.i32().name("patience_mult_x100"),
  usedToilet: __t.bool().name("used_toilet"),
  willWashOnly: __t.bool().name("will_wash_only"),
  washedHands: __t.bool().name("washed_hands"),
  wcCompleted: __t.bool().name("wc_completed"),
  onStair: __t.bool().name("on_stair"),
  greeted: __t.bool(),
  regularId: __t.u64().name("regular_id"),
  regularName: __t.option(__t.string()).name("regular_name"),
});
